// @Version: 1.0.0
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getMax',
  standalone: false
})
export class GetMaxPipe implements PipeTransform {
   constructor () {}

   transform (attribute_5: string | undefined, attribute_3: string | undefined): number {
      return Number(attribute_5 ?? 0) + Number(attribute_3 ?? 10) - 1;
   }
}